import * as prismic from 'https://cdn.skypack.dev/@prismicio/client'
import * as prismicH from 'https://cdn.skypack.dev/@prismicio/helpers'

const sectionImageWithText = document.querySelectorAll(
  '.section-image-with-text'
)

const container = document.querySelector(
  '.product-info-blocks__container'
)

sectionImageWithText.forEach(section => section.remove())

const repoName = 'ateliers-foures'
const client = prismic.createClient(repoName)



const init = async () => {
 const prismicDoc = await client.getAllByType('infos_block')
 const blocks = prismicDoc
  
  metaIds = metaIds.map(id => Number(id))
  const filteredBlocks = blocks.filter(block => metaIds.includes(block.data.id))

 filteredBlocks.forEach((block, index) => {
  const body = block.data.body[0]
   container.innerHTML = container.innerHTML + blockTemplate(
     prismicH.asText(body.primary.title), prismicH.asText(body.primary.text), prismicH.asImageSrc(body.primary.image), body.primary.bg_color, body.primary.heading_color, index % 2 !== 0
   )
 })

    productInfoBlockHide()
}


function blockTemplate(title, text, image, bgColor, titleColor, isReverse) {
  return `<div class="product-info-block rel f ${isReverse && 'frr'}">

  <div class="abs top left x y z2 last-image-with-text__layer--more pointer is-hidden">
        <div class="last-image-with-text__seemore abs bottom ttu bold f nw">
          Lire la suite
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
        </div>
      </div>
      <div class="abs bottom left x y z2 last-image-with-text__layer--less pointer is-hidden">
        <div class="last-image-with-text__seeless abs bottom ttu bold f nw">
          Lire moins
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
        </div>
      </div>

  
      <div class="product-info-block__image x rel" style="${isReverse && 'text-align: right'}">
        <div class="media-bg" style="background-color: ${bgColor}; ${isReverse && 'right: -15px'}"></div>
        <img class="y" style="${!isReverse && 'margin-left: 15px'}" src="${image}" alt="">
      </div>
      <div class="x f aic">
        <div>
          <h2 class="ttu bold image-with-text__heading h1" style="color: ${titleColor && titleColor}">${title}</h2>
          <p class="image-with-text__text image-with-text__text--caption">${text}</p>
        </div>
        
      </div>
    </div>`;
}

function productInfoBlockHide() {
	const LIMIT = window.innerWidth > 749 ? 4 : 2
	const sections = document.querySelectorAll('.product-info-block')
	const lastSection = sections[LIMIT]

	if(!lastSection) return

	const ultimateSection = [...sections].pop()
	const layerMore = lastSection.querySelector('.last-image-with-text__layer--more')
	const layerLess = ultimateSection.querySelector('.last-image-with-text__layer--less')
	const seemore = lastSection.querySelector('.last-image-with-text__seemore')
	const seeless = ultimateSection.querySelector('.last-image-with-text__seeless')

  

	const seemoreClick = () => {
		sections.forEach(section => section.classList.remove('is-hidden'))
		layerMore.classList.add('is-hidden')
		layerLess.classList.remove('is-hidden')
	}

	const seelessClick = () => {
		sections.forEach((section, index) => {
			if(index <= LIMIT) return
			section.classList.add('is-hidden')
		})

		layerLess.classList.add('is-hidden')
		layerMore.classList.remove('is-hidden')
	}

	for(let i = LIMIT + 1; i < sections.length; i++) {
		sections[i].classList.add('is-hidden');
	}

	layerMore.classList.remove('is-hidden')

	seemore.addEventListener('click', seemoreClick)
	seeless.addEventListener('click', seelessClick)

	window.onunload = function() {
		seemore.removeEventListener('click', seemoreClick)
		seeless.removeEventListener('click', seelessClick)
	}
}

 init()

/*const productInfoBlocks = [...document.querySelectorAll('.product-info-block')]
const sectionImageWithText = document.querySelectorAll(
  '.section-image-with-text'
)

console.log(productInfoBlocks)
const productInfoBlocksContainer = document.querySelector(
  '.product-info-blocks__container'
)
let filteredInfoBlocks = null

if (metaIds) {
  filteredInfoBlocks = productInfoBlocks.filter(infoBlock =>
    metaIds.find(id => id === infoBlock.dataset.blockId)
  )

  filteredInfoBlocks.sort(
    (a, b) =>
      metaIds.indexOf(a.dataset.blockId) - metaIds.indexOf(b.dataset.blockId)
  )
}

sectionImageWithText.forEach(section => section.remove())

if (productInfoBlocksContainer) {
  filteredInfoBlocks.forEach(node =>
    productInfoBlocksContainer.appendChild(node)
  )

  const grids = document.querySelectorAll('.image-with-text__grid')

  grids.forEach((grid, index) => {
		const media = grid.querySelector('.media-bg')

		if(index % 2){
			media && media.classList.add('media-bg--right')
      grid.classList.add('image-with-text__grid--reverse')
      grid.classList.add('image-with-text__grid--right')

		}else{
			media && media.classList.add('media-bg--left')
      grid.classList.remove('image-with-text__grid--reverse')
			grid.classList.add('image-with-text__grid--left')
		}
  })

	productInfoBlockHide()
}




*/